import {useState} from 'react';

export const useSearchBarOpenedState = () => {
  const [isSearchBarExpanded, setIsSearchBarExpanded] = useState(false);

  const expandSearchBar = () => {
    setIsSearchBarExpanded(true);
  };

  const collapseSearchBar = () => {
    setIsSearchBarExpanded(false);
  };

  return {isSearchBarExpanded, expandSearchBar, collapseSearchBar};
};
